import { defineAsyncComponent } from 'vue'
export default {
  custom: defineAsyncComponent(() => import("/codebuild/output/src25092165/src/actions-runner/_work/onenews/onenews/web-services/onenews/layouts/custom.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/codebuild/output/src25092165/src/actions-runner/_work/onenews/onenews/web-services/lego-land/layouts/default.vue").then(m => m.default || m))
}